var _g, _g2, _circle, _g3, _path, _path2, _circle2, _path3, _path4, _circle3, _g4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgK900Vector(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1200 1200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#363c42"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 395.5,
    cy: 390,
    r: 228
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 808,
    cy: 390,
    r: 228
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#515960"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 395.5,
    cy: 390,
    r: 123
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 808,
    cy: 390,
    r: 123
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 599.5,
    cy: 664.5,
    r: 361,
    fill: "#007cbd"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#005b8e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M239 658h721v13H239z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 600,
    cy: 665,
    r: 88
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M689.71 671v78.95H509V671",
    fill: "#007cbd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M638.44 610.32h0a13.01 13.01 0 0 1-.76-18.37l24.42-26.52a13.01 13.01 0 0 1 18.37-.76h0a13.01 13.01 0 0 1 .76 18.37l-24.42 26.52a13.01 13.01 0 0 1-18.37.76zm-73.28 3.54h0a13 13 0 0 1-18.37-.76l-27.77-30.15a13.01 13.01 0 0 1 .76-18.37h0a13.01 13.01 0 0 1 18.37.76l27.77 30.15a13.01 13.01 0 0 1-.76 18.37z",
    fill: "#005b8e"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 600,
    cy: 665,
    r: 72,
    fill: "#363c42"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M556.44 775h87.12c15.71 0 28.44 12.73 28.44 28.44v137.31c0 6.94-2.54 13.64-7.14 18.84-18.59 21.04-71.17 67.34-129.85 1-4.55-5.15-7.01-11.82-7.01-18.7V803.44c0-15.71 12.73-28.44 28.44-28.44z",
    fill: "#515960"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M897 776H303c-7.18 0-13-5.82-13-13h0c0-7.18 5.82-13 13-13h594c7.18 0 13 5.82 13 13h0c0 7.18-5.82 13-13 13z",
    fill: "#005b8e"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 600,
    cy: 948,
    r: 32,
    fill: "#c13e3e"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 580,
    cy: 811,
    r: 12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 580,
    cy: 849,
    r: 12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 580,
    cy: 887,
    r: 12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 620,
    cy: 811,
    r: 12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 620,
    cy: 849,
    r: 12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 620,
    cy: 887,
    r: 12
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgK900Vector);
export default __webpack_public_path__ + "static/media/K900_Vector.dc5be1f65558de402fd95a41e78b7854.svg";
export { ForwardRef as ReactComponent };